module.exports = __webpack_public_path__ + "img/inaridou.55482d41.jpg";